// extracted by mini-css-extract-plugin
export default {"page":"Login_page__uz+xv"};